import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);

const relatedSlider = new Swiper(
  '.single-product-page__related__container__slider',
  {
    slidesPerView: 1,
    spaceBetween: 20,
    slidesPerGroup: 1,
    speed: 500,
    breakpoints: {
      600: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        speed: 1000,
      },
      900: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      1200: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },
      1800: {
        slidesPerView: 5,
        slidesPerGroup: 5,
      },
    },

    pagination: {
      el: '.single-product-page__related__container__slider__pagination',
    },

    navigation: {
      nextEl: '.single-product-page__related__container__slider__next',
      prevEl: '.single-product-page__related__container__slider__prev',
    },
  }
);
